export const getWindowWidth = () => {
  var win = window,
    doc = document,
    docElem = doc.documentElement,
    body = doc.getElementsByTagName('body')[0],
    windowWidth = win.innerWidth || docElem.clientWidth || body.clientWidth;
  return windowWidth;
};
